export type TimelineExportState = {
    loading: boolean;
    success: boolean;
    url: string;
};

export const initialTimelineExport: TimelineExportState = {
    loading: false,
    success: false,
    url: '',
};
